import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callContractorPortalSecureApi } from '../api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import {
  ContractorPortalFetchDriver,
  ContractorPortalUploadDebitCard,
} from 'src/constants/actionTypes'
import {
  PaymentMethodRecipientNamePreference,
  PaymentMethodTypeEnum,
} from 'src/interfaces/paymentMethod'
import { getApiErrorMessage } from 'src/utils/errorHandlers'

interface ContractorPortalDebitCardRequest {
  cardNumber: string
  cardExpiration: string
  zipcode: string
  recipientNamePreference: PaymentMethodRecipientNamePreference
  token?: string | null
}

function* onContractorPortalUploadDebitCard(action: AsyncAction<ContractorPortalDebitCardRequest>) {
  const { cardNumber, cardExpiration, zipcode, recipientNamePreference, token } = action.payload

  try {
    yield call(callContractorPortalSecureApi, Endpoints.FetchPaymentMethod, {
      method: 'POST',
      query: token ? { token } : undefined,
      body: {
        paymentMethodType: PaymentMethodTypeEnum.Card,
        recipientNamePreference,
        cardDetails: {
          cardNumber,
          cardExpiration,
          zipcode,
        },
      },
      apiService: ApiService.Paraworks,
    })

    yield put(ContractorPortalUploadDebitCard.success())

    yield put(ContractorPortalFetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = getApiErrorMessage(err, 'Failed to upload debit card')

    yield put(ContractorPortalUploadDebitCard.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* contractorPortalDebitCardSaga() {
  yield takeLatest(ContractorPortalUploadDebitCard.type.REQUEST, onContractorPortalUploadDebitCard)
}
